<template>
    <div id="myModal" class="modal-background" v-if="searchfacet">
        <div class="modal">
            <div class="modal-header">
                <span class="close" @click="onClose()"><img class="selected-filter__remove-icon" src="/Themes/Striep2/Content/svg/x.svg" style="width: 28px;" /></span>
                <h2>{{searchfacet}}</h2>
                <!--<input type="search" />-->
              
            </div>
            <div class="modal-body">
                <div v-for="group in groupedData" class="facet-group" :key="group[0].letterGroup">
                    <div class="facet-group__header">
                        <span>{{ group[0].letterGroup }}</span>
                    </div>
                    <ul class="facet-group__items">
                        <li v-for="item in group" :key="item.label">
                            <input class="hovercursor" v-model="selected" type="checkbox" v-bind:value="item.id" v-bind:name="item.id" v-bind:id="item.id" />
                            <label class="hovercursor" v-bind:for="item.id">{{item.label}}</label><br>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn-primary-alternative" @click="onClickViewResults">Bekijk resultaten</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'product-page-filterdialog-component',
        props: ['searchfacet', 'selectedinput', 'selectedfacets', 'page'],
        data: function () {
            return {
                items: [],
                filteredItems: [],
                selected: [],
                searchQuery: ''
            }
        },
        computed: {
            groupedData: function() {
                let grouped = this.filteredItems.reduce(function(h, obj) {
                    h[obj.letterGroup] = (h[obj.letterGroup] || []).concat(obj);
                    return h; 
                }, {})

                return grouped;
            },
            placeholder: function() {
                return `Zoek ${this.searchfacet}`
            }
        },
        mounted() {
            this.selected = this.selectedinput;
            this.fetchData();
        },
        methods: {
            getLabel: function(item) {
                let found = this.items.find(x => x.id == item);
                if(found)
                    return found.label;
            },
            searchQueryUpdated: function() {
                // this.filteredItems = search(this.items, ['label'], this.searchQuery);
                this.filteredItems = this.items.filter(i => i.label.toLowerCase().includes(this.searchQuery.toLowerCase()))
                // this.filteredItems = null;
            },
            onClose: function () {
                this.$emit("closedialog", this.searchfacet);
                document.querySelector('.master-wrapper-content').style.zIndex = "0"
            },
            fetchData: function () {
                //http://localhost:8080/SolrCategoryValues?category=reeks
                // let url = `/SolrCategoryValues?page=strips&category=${this.searchfacet}&filters=${this.selectedFacets}`;
                let url = this.buildAjaxUrl(this.searchfacet, this.selectedfacets)
               
                fetch(url)
                    .then(result => result.json())
                    .then(json => {
                        this.items = json;
                        this.filteredItems = json;
                    });
            },
            onClickSelectedFilter: function ($event, value) {
                this.selected = this.selected.filter(s => s !== value);
            },
            onClickRemoveAllFilters: function () {
                this.selected = [];
            },
            onClickViewResults: function () {
                this.$emit("facetsselected", this.selected);
                document.querySelector('.master-wrapper-content').style.zIndex = "0"
            },
            buildAjaxUrl(category, selectedFacets) {
                let url = `/SolrCategoryValues?page=${this.page}&category=${category}`;
                selectedFacets.forEach(f => {
                    f.values.forEach(v => {
                        url += `&${f.name}=${v}`;
                    })
                })

                return url;
            }
        }
    }
</script>